<template>
    <modal width="500px">
        <div slot="body">
            <div class="title" style="font-size:1.2em; white-space: normal; text-align: center">
                {{ $t('could_not_be_created')}}
            </div>
            <div class="errors" v-if="errors">
                <div class="error" v-for="error in errors" :key="error">
                    {{error | moment('DD/MM/YYYY  HH:mm')}}
                </div>
            </div>
            <div class="buttons">
                <button class="btn-black" @click="$emit('close')">
                    {{$t('close')}}
                </button>
            </div>
        </div>
    </modal>
</template>
<script>
import Modal from './../components/Modal'
export default {
  name: '',
  components: {Modal},
  props: ['errors'],
  created () {
  },
  mounted () {
    const promises = [
    ]
    Promise.all(promises).then(data => { })
  },
  data () {
    return {
    }
  }
}
</script>
<style lang="scss" scoped>
    .errors{
        display: flex;
        flex-direction: column;
        .error {
            background: #C9D713;
            display: inline-block;
            font-size: 1.1em;
            text-align: center;
            margin: .2em 2.5em;
            padding: .2em 0;
            border-radius: .5em;
        }
    }
    .buttons{
        display: flex;
        margin-top: .5em;
        justify-content: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/CreateErrorsModal.vue